import React from "react";
import CuentasBancariasBase from "./CuentasBancariasBase";

export default function CuentasBancarias() {
  return <CuentasBancariasBase tipo="Bancaria" />;
}
